<div class="dark-background">
  <div class="img-container">
    <slotcom-navigation-button
      type="close"
      topPosition="5.5"
      rightPosition="-3"
      (click)="closeModal()"></slotcom-navigation-button>

    <slotcom-navigation-button
      type="info"
      topPosition="9"
      width="3"
      height="3"
      leftPosition="3.5"
      (click)="openInfo()"></slotcom-navigation-button>

    <slotcom-streak></slotcom-streak>
    <div class="img-background"></div>
  </div>

  <div class="text-container">
    <slotcom-p
      class="text-title"
      [bold]="true"
      [text]="'home.streak.title' | translate | uppercase"
      [shadowBorder]="false"></slotcom-p>
    <slotcom-p
      class="text-state"
      [bold]="true"
      [text]="modalStreakInfo.stateText | translate"
      [shadowBorder]="false"></slotcom-p>
  </div>

  <div class="steps-container">
    @if (streak.current > streak.threshold || (streak.current >= streak.threshold && !streak.achievedToday)) {
      <div class="step">
        <div class="step-arrow"></div>
        <div
          class="step-box"
          data-testid="slotcom-dailyChallenge-streak-box">
          @if (streak.achievedToday) {
            <img
              imgLoadedCompleted
              [src]="modalStreakInfo.greenStep"
              class="step-state" />
          } @else {
            <img
              imgLoadedCompleted
              [src]="modalStreakInfo.emptyStep"
              class="step-state" />
          }
        </div>
      </div>
    } @else {
      @for (step of streakSteps; track step; let i = $index) {
        <div class="step">
          @if (i === 0 && streak.current === 0) {
            <div class="step-arrow"></div>
          }
          @if (streak.current > 0 && streak.achievedToday && i === streak.current - 1) {
            <div class="step-arrow"></div>
          }
          @if (streak.current > 0 && !streak.achievedToday && i === streak.current) {
            <div class="step-arrow"></div>
          }
          <div class="step-box">
            @if (streak.achievedToday && streak.current - 1 === i) {
              <img
                imgLoadedCompleted
                [src]="modalStreakInfo.greenStep"
                class="step-state" />
            } @else if (i < streak.current && streak.current > 0) {
              <img
                imgLoadedCompleted
                [src]="modalStreakInfo.yellowStep"
                class="step-state" />
            } @else {
              <img
                imgLoadedCompleted
                [src]="modalStreakInfo.emptyStep"
                class="step-state" />
            }
          </div>
        </div>
      }
    }
  </div>
  <div class="footer-container">
    <slotcom-p
      class="text-activate"
      [bold]="true"
      [text]="modalStreakInfo.lockedText | translate"
      [shadowBorder]="false"></slotcom-p>

    <div class="reward-box-container">
      <img
        imgLoadedCompleted
        [src]="modalStreakInfo.lockIcon"
        class="lock-icon" />

      <div
        class="reward-box"
        [ngClass]="{ 'reward-box--inactive': streak.current < streak.threshold }">
        <slotcom-p
          class="text-info"
          [bold]="true"
          [text]="modalStreakInfo.rewardText | translate"
          [shadowBorder]="false"></slotcom-p>
      </div>
    </div>
  </div>
</div>
